import { render, staticRenderFns } from "./BaseFileDrop.vue?vue&type=template&id=d6634a70&scoped=true"
import script from "./BaseFileDrop.vue?vue&type=script&lang=js"
export * from "./BaseFileDrop.vue?vue&type=script&lang=js"
import style0 from "./BaseFileDrop.vue?vue&type=style&index=0&id=d6634a70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6634a70",
  null
  
)

export default component.exports